module.exports = __webpack_public_path__ + "img/main-banner.96afa02e.jpg";